module.exports = __webpack_public_path__ + "static/media/relatorio.2cf8be21.svg";